export default __webpack_public_path__ + "static/media/IUSD.828243c7.png";